import { useQuery, useQueryClient } from "@tanstack/react-query"

export type AppId = "nzeroos" | "retrospec"

const getAppId = (): AppId => {
  return window.location.hostname.includes("retrospec")
    ? "retrospec"
    : "nzeroos"
}

/**
 * Returns the app id
 *
 * @example
 * const appId = useAppId()
 */
export const useAppId = (): AppId => {
  const queryClient = useQueryClient()
  const queryKey = ["appId"]

  const { data } = useQuery({
    gcTime: Infinity,
    initialData: getAppId(),
    networkMode: "always",
    queryFn: async (): Promise<AppId> =>
      queryClient.getQueryData(queryKey) ?? getAppId(),
    queryKey,
    staleTime: Infinity,
  })

  return data
}
